import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';
import { SourceLogo } from 'components/sharpr/sourceLogo/SourceLogo';

export default function NewsroomScreenRunSingleRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.NewsroomScreenRunSingle', {
		url: '/newsroom/single/:code',
		controllerAs: 'vm',
		controller: NewsroomScreenRunSingleCtrl,
		templateUrl: '/ng/hub/Newsroom/Screen/Run/Single/NewsroomScreenRunSingleCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Screen/Run/Single/NewsroomScreenRunSingleCtrl.css'),
			$title: () => 'Newsroom :: Slideshow',
			newsroom: ApiResourcify.public('/newsrooms/screens/run/:code'),
			sourceLogos: ApiResourcify.public('/feeds/logos'),
		},
	});
}

class NewsroomScreenRunSingleCtrl {
	constructor(newsroom, $timeout, Api, Theme, sourceLogos, modal, Pubnub, ErrorScreen) {
		'ngInject';
		this.newsroom = ensure.object(newsroom);
		this.posts = ensure.array(this.newsroom.posts);
		this.numPosts = this.posts.length;
		if (this.numPosts < 2) {
			ErrorScreen.show({
				class: 'not-allowed',
				title: 'Not enough content',
				message: 'This newsroom screen needs more posts before it can be displayed.',
				actionText: 'Home',
				actionUrl: '/',
			});
			return;
		}
		this.Api = Api;
		this.Theme = Theme;
		this.$timeout = $timeout;
		// TODO: make it possible to pick a random transition
		this.transition = ensure.object(this.newsroom.options.elements).transition || 'crossfade';
		this.duration = ensure.object(this.newsroom.options.elements).duration || 30;
		SourceLogo.splice(sourceLogos, this.posts, 'white');
		this.processPosts();
		this.idx = 0;
		this.queueNext();

		window.addEventListener('keyup', evt => {
			if ([37, 38].indexOf(evt.which) > -1) {
				// left key or up key
				this.keyPrev();
			} else if ([39, 40, 32].indexOf(evt.which) > -1) {
				// right key or down key or spacebar
				this.keyNext();
			}
		});

		Pubnub.awaitReload('newsroom_' + this.newsroom.code);
		if (this.newsroom.options.elements.fullscreen !== '0') {
			modal
				.fullscreen({
					text: 'Go fullscreen?',
					heading: 'Newsroom Mode',
					timeoutMs: 8000,
				})
				.then(
					() => {},
					() => {}
				);
		}
		if (this.newsroom.options.elements.refresh > 0) {
			setInterval(() => {
				this.Api.get(`/newsrooms/screens/run/${this.newsroom.code}`, null, {
					Authorization: 'Public',
				}).then(newsroom => {
					const newsroomObject = ensure.object(newsroom);
					const updatedPosts = ensure.array(newsroomObject.posts);

					if (updatedPosts.length > 0) {
						this.posts = updatedPosts;
					}

					this.processPosts();
				});
			}, this.newsroom.options.elements.refresh * 1000);
		}
	}

	processPosts() {
		this.posts.forEach((post, i) => {
			// styles
			post.styles = {
				backgroundColor: this.newsroom.colors[i % this.newsroom.colors.length].bgColor,
				zIndex: 2,
			};
			// classes
			post.class = 'out';
			// card text
			if (this.newsroom.options.elements.postText === 'insight' && _.trim(post.intel_text) !== '') {
				post.cardText = post.intel_text;
			} else {
				post.cardText = post.headline;
			}
			// logo
			post.credit = this.newsroom.options.elements.credit;
			if (post.credit == 'hubLogo') {
				post.hubLogo = post.logos.on_light;
			} else if (post.credit == 'userAvatar') {
				post.userAvatar = post.published_by ? post.published_by.avatar : null;
			} else if (post.credit == 'sourceLogo') {
				if (post.source_logo) {
					post.sourceLogo = post.source_logo;
				} else {
					post.sourceName = post.source_name || post.domain_name;
				}
			}
		});
	}

	queueNext() {
		// swap this post and next post
		this.thisPost = this.posts[Math.abs(this.idx % this.posts.length)];
		this.nextPost = this.posts[Math.abs((this.idx + 1) % this.posts.length)];
		this.currentPosts = [this.thisPost, this.nextPost];
		// set the css classes that trigger the animation
		this.thisPost.class = 'in';
		this.nextPost.class = 'out';
		this.transitionInNew = this.$timeout(() => {
			// start transitioning in new slide
			if (this.nextPost) {
				this.nextPost.class = 'in';
			}
			// after transition completes, update this/next
			this.readyToSwap = this.$timeout(() => {
				// new slide has completely transitioned in
				if (this.thisPost && this.thisPost.styles) {
					this.thisPost.styles.zIndex = 1;
				}
				this.queueNext();
				this.doneTransitioningOut = this.$timeout(() => {
					// new slide has completely transitioned out
					if (this.nextPost && this.nextPost.styles) {
						this.nextPost.styles.zIndex = 2;
					}
				}, 2100);
			}, 2100);
		}, this.duration * 1000);
		this.idx++;
	}

	keyNext() {
		this.cancelTimeouts();
		this.$timeout(() => {
			this.queueNext();
		});
	}

	keyPrev() {
		this.cancelTimeouts();
		this.$timeout(() => {
			this.idx -= 2;
			this.queueNext();
		});
	}

	cancelTimeouts() {
		try {
			this.$timeout.cancel(this.transitionInNew);
			this.$timeout.cancel(this.readyToSwap);
			this.$timeout.cancel(this.doneTransitioningOut);
			this.thisPost.styles.zIndex = 1;
			this.nextPost.styles.zIndex = 2;
		} catch (e) {}
	}
}
